// Market lifecycle modal — analytics event (spec 112-market-lifecycle-modals).
// Fired once when a graduation or resolution lifecycle modal is shown to a
// connected user on the market / winner page.

import type { LifecycleStage, LifecycleVariant } from '@/stores/market-lifecycle-modal';

export type MarketLifecycleModalShownProperties = {
  marketPubkey: string;
  stage: LifecycleStage;
  variant: LifecycleVariant;
};

export const MARKET_LIFECYCLE_MODAL_SHOWN = 'market_lifecycle_modal_shown';
